<template>
  <div>
    <v-progress-linear v-if="sending" indeterminate value="0"></v-progress-linear>
    <input type="file" ref="file" style="display: none" @change="onChange" />
    <div @dragover.prevent @drop="onDrop" flat :loading="loading">
      <div class="float-left width-full">
        <div v-if="dragging" class="drop align-center" @dragover.prevent @drop="onDrop">
          <div class="helper"></div>
          <label class="btn display-inline">
            <v-icon color="#808F9C" size="50px">cloud_upload</v-icon>
            <div>{{message}}</div>
            <input type="file" ref="file" name="image" @change="onChange" />
          </label>
        </div>

        <div v-if="!dragging" class="width-full float-left">
          <v-textarea
            :disabled="sending"
            class="custom-big mt-0"
            :class="lightBcg ? 'bcg-light' : 'bcg-main'"
            @click="edit=true"
            v-model="description"
            ref="message"
            color="#4dbac0"
            rows="6"
            auto-grow
            :label="placeholder"
            rounded
          >
            <template slot="prepend-inner">
              <v-icon v-if="icon" color="#808F9C">chat</v-icon>
            </template>
            <template slot="append">
              <div class="image-upload">
                <label v-if="upload" for="file-input" @click="$refs.file.click()">
                  <v-btn icon>
                    <v-icon>attach_file</v-icon>
                  </v-btn>
                </label>

                <v-btn
                  :disabled="description ? false : image.length > 0 ? false : true"
                  v-if="sendBtn"
                  icon
                  @click="send"
                >
                  <v-icon>send</v-icon>
                </v-btn>

                <input id="file-input" type="file" />
              </div>
            </template>
          </v-textarea>
        </div>
        <transition name="scroll-y-transition" mode="out-in">
          <div v-if="image.length >0" class="width-full float-left attachements">
            <transition-group name="list">
              <div
                v-for="(img,index) in image"
                :key="img"
                class="display-inline align-center"
                v-bind:class="{ 'image': true }"
              >
                <img :src="img" alt class="img mx-4" />

                <span class="delete" @click="removeFile(index)">
                  <v-icon color="#E62163" size="30" dark>cancel</v-icon>
                </span>
              </div>
            </transition-group>
          </div>
        </transition>
        <!--
        <div v-if="edit" class="width-full float-left px-2">
          <v-card-actions>
            <v-btn @click="clearEdit" text>Cancel</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="upload" text>SAVE</v-btn>
          </v-card-actions>
        </div>
        -->
      </div>
    </div>
  </div>
</template>

<script>
//import axios from "axios";
export default {
  props: {
    parentId: String,
    parentType: String,
    default: String,
    placeholder: String,
    reset: Date,
    sendBtn: Boolean,
    sending: Boolean,
    lightBcg: Boolean,
    icon: Boolean,
    upload: Boolean
  },
  data() {
    return {
      resetData: new Date(),
      response: "",
      loading: false,
      uploading: false,
      image: [],
      file: [],
      message: "Drag files here !",
      description: "",
      edit: false,
      dragging: false,
      model: this.value,
      totop: "totop-off",
      dimmer: "dimmer-off",
      inputRows: 1,
      emitData: { files: [], description: null }
    };
  },
  mounted() {
    this.description = this.default
  },
  beforeDestroy() {},
  watch: {
    reset: function(newVal) {
      if (newVal != this.resetData) {
        this.description = "";
        this.image = [];
        this.file = [];
        this.emitData = { files: [], description: null };
      }
    },
    file: function(newVal) {
      this.$emit("imgData", newVal);
    },
    description: function(newVal) {
      this.$emit("textData", newVal);
    },
    edit: function(newVal) {
      if (newVal === true) {
        this.totop = "totop";
        this.dimmer = "dimmer";
        this.inputRows = 4;
      } else {
        this.totop = "totop-off";
        this.dimmer = "dimmer-off";
        this.inputRows = 1;
      }
    }
  },
  methods: {
    send() {
      this.$emit("sending", true);
    },
    clearEdit() {
      this.description = "";
      this.image = [];
      this.file = [];
      this.edit = false;
      this.loading = false;
      this.emitData.description = "";
      this.emitData.files = [];
    },
    dropfalse: function(e) {
      e.stopPropagation();
      e.preventDefault();
      //alert("drpoe");
      this.dragging = false;
      if (this.description == "" && this.image.length == 0) {
        this.edit = false;
        this.totop = "totop-off";
        this.dimmer = "dimmer-off";
      }
    },
    dragenter: function(e) {
      e.stopPropagation();
      e.preventDefault();
      this.edit = true;
      this.dragging = true;
      this.message = "Drop here !";
      this.totop = "totop";
    },
    dragleave: function(e) {
      e.stopPropagation();
      e.preventDefault();
      this.edit = false;
      this.dragging = false;
      this.message = "Drag files here !";
      this.totop = "";
      this.dimmer = "dimmer-off";
    },

    // image upload workaround
    onDrop: function(e) {
      if (this.upload) {
        e.stopPropagation();
        e.preventDefault();
        this.edit = true;
        this.dragging = false;
        var files = e.dataTransfer.files;

        this.file.push(files[0]);
        this.createFile(files[0]);

        this.emitData.files.push(files[0]);
      }
    },
    onChange(e) {
      if (this.upload) {
      var files = e.target.files;
      /*
     e.target.files.forEach(fajl =>{
         this.file.push(fajl);
         this.createFile(fajl);
      })
      */
      this.file.push(files[0]);
      this.createFile(files[0]);
      this.emitData.files.push(files[0]);
      }
    },

    createFile(file) {
      if (this.upload) {
      if (!file.type.match("image.*")) {
        alert("Select an image");
        return;
      }

      var reader = new FileReader();
      var vm = this;

      reader.onload = function(e) {
        vm.image.push(e.target.result);
      };

      reader.readAsDataURL(file);

      //this.upload();
      }
    },
    removeFile(index) {
      this.image.splice(index, 1);
      this.file.splice(index, 1);
      if (this.image.length == 0 && this.description == "") {
        this.edit = false;
      }
      //this.uploading = false;
    },
    resetFile() {
      this.image = [];
      this.file = [];
      this.edit = false;
      this.description = "";
      //this.uploading = false;
      this.emitData.description = "";
      this.emitData.files = [];
    }
  }
};
</script>

<style scoped>
.image-upload > input {
  display: none;
}

.custom-big {
  border-radius: 5px;
}

.bcg-main {
  background-color: #333b47 !important;
}
.bcg-light {
  background-color: #28303d !important;
}

.rounded-card {
  padding-top: 3px;
}

.postInput input[type="text"] {
  margin-right: 15px;
  height: 40px !important;
  width: 100%;
  border-radius: 20px;
  border: 0px;
  padding-left: 21px;
  background-color: #333b47 !important;
  color: white;
  font-size: 12px;
}
.btn {
  border: 0;
  border-radius: 5px;
  color: #808f9c;
  height: 144px;
  cursor: pointer;
  display: inline-block;
  font-weight: bold;
  padding-top: 5px;
  transition: 0.2s;
  width: 100%;
}

.btn:hover {
  background-color: #1e242e;
  color: white;
}

.btn-hover {
  background-color: #1e242e;
}

input[type="file"] {
  position: absolute;
  opacity: 0;
  z-index: -1;
}

.align-center {
  text-align: center;
}

.helper {
  height: 100%;
  display: inline-block;
  vertical-align: middle;
  width: 0;
}

.hidden {
  display: none !important;
}

.hidden.image {
  display: inline-block !important;
}

.display-inline {
  display: inline-block;
  vertical-align: middle;
}

.img {
  display: inline-block;
  height: 100px;
  width: 100px;
}

.drop {
  border: 2px dashed #808f9c;
  border-radius: 5px;
  height: 150px;
  width: 100%;
}

.delete {
  position: absolute;
  margin-left: -120px;
  margin-top: -3px;
  width: 25px;
  height: 25px;
  background-color: black;
  border-radius: 50%;
  transition: 0.3s;
  cursor: pointer;
  color: black;
  z-index: 999;
}

.drag-right-out {
  position: fixed; /* important to use fixed, not absolute */
  top: 0;
  right: 0;
  width: 40px;
  height: 100%;
  z-index: 9999; /* may not be necessary 
  /*border: 1px solid red;*/
}
.drag-right-in {
  position: fixed; /* important to use fixed, not absolute */
  top: 0;
  right: 40px;
  width: 40px;
  height: 100%;
  z-index: 9999; /* may not be necessary */
  /*border: 1px solid blue;*/
}

.dimmer {
  background: black;
  opacity: 0.4;
  position: fixed; /* important to use fixed, not absolute */
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10; /* may not be necessary */
  transition: 0.5s;
}
.dimmer-off {
  background: none;
  z-index: -10 !important; /* may not be necessary */
  position: fixed; /* important to use fixed, not absolute */
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: 0.5s;
}

.totop {
  z-index: 9999 !important;
  min-height: 0px;
  transition: 0.5s;
}

.max-height {
  max-height: 1000px;
}
.totop-off {
  z-index: 0;
  max-height: 100px;
  transition: 0.2s;
}

.attachements {
  background-color: #333b47 !important;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  padding: 15px;
  border-top: 1px dotted #808f9c;
}
</style>